const WelcomeState = () => (
    <section className="admin-pages-form">
        <div className="admin-pages-welcome-state">
            <div className="admin-pages-welcome-icon"><i className="pi pi-pencil" /></div>
            <h2 className="admin-text-2xl mb-6">Gestor de páginas de contenido</h2>
            <div className="admin-pages-welcome-cards">
                <div className="admin-welcome-card">
                    <div className="admin-welcome-card-icon"><i className="pi pi-file" /></div>
                    <h4 className="admin-text-base">Selecciona una página</h4>
                    <p className="admin-text-sm">Elige una página existente de la lista para editarla</p>
                </div>
                <div className="admin-welcome-card">
                    <div className="admin-welcome-card-icon"><i className="pi pi-plus" /></div>
                    <h4 className="admin-text-base">Crea una nueva</h4>
                    <p className="admin-text-sm">Haz clic en "Nueva página" para comenzar desde cero</p>
                </div>
                <div className="admin-welcome-card">
                    <div className="admin-welcome-card-icon"><i className="pi pi-check" /></div>
                    <h4 className="admin-text-base">Agrega bloques</h4>
                    <p className="admin-text-sm">Elige el tipo de contenido que necesitas y personalízalo</p>
                </div>
            </div>
            <div className="admin-pages-welcome-tips">
                <h4 className="admin-text-base"><i className="pi pi-info-circle" /> Tips: </h4>
                <ul className="admin-text-sm">
                    <li>- Cada bloque de contenido es una sección independiente en la página</li>
                    <li>- Los cambios se guardan automáticamente al hacer clic en "Guardar página"</li>
                </ul>
            </div>
        </div>
    </section>
);

export default WelcomeState;
